import qs from 'qs';
import FileDownload from 'react-file-download';
import irelandApi from '../irelandApi';
import {
  GET_PERSONAL_POINTS_ACTIVITY_PENDING,
  GET_PERSONAL_POINTS_ACTIVITY_FULFILLED,
  GET_PERSONAL_POINTS_ACTIVITY_REJECTED,
  GET_POINTS_STATEMENT_OUTLETS_PENDING,
  GET_POINTS_STATEMENT_OUTLETS_FULFILLED,
  GET_POINTS_STATEMENT_OUTLETS_REJECTED
} from '../reducers/pointsStatementReducer';


export const getPersonalPointsStatement = (page, filters = {}) => (dispatch) => {
  dispatch({type: 'GET_PERSONAL_POINTS_STATEMENT_PENDING'});
  const params = {
    page,
    filters
  };
  return irelandApi.get(`/api/points_statement?${qs.stringify(params, {encodeValuesOnly: true})}`)
    .then((response) => {
      dispatch({
        type: 'GET_PERSONAL_POINTS_STATEMENT_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_PERSONAL_POINTS_STATEMENT_REJECTED',
        payLoad: error.data
      });
    });
};

export const getOutletsForPointsStatement = () => (dispatch) => {
  dispatch({type: GET_POINTS_STATEMENT_OUTLETS_PENDING});
  return irelandApi.get('/api/points_statement/outlets')
    .then((response) => {
      dispatch({
        type: GET_POINTS_STATEMENT_OUTLETS_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_POINTS_STATEMENT_OUTLETS_REJECTED,
        payLoad: error.data
      });
    });
};

export const getPersonalPointsActivity = (outletId, page = 1) => (dispatch) => {
  dispatch({type: GET_PERSONAL_POINTS_ACTIVITY_PENDING});
  return irelandApi.get(`/api/outlets/${outletId}/personal_points`, {params: {page}})
    .then((response) => {
      dispatch({
        type: GET_PERSONAL_POINTS_ACTIVITY_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PERSONAL_POINTS_ACTIVITY_REJECTED,
        payLoad: error.data
      });
    });
};


export const downloadPoints = pot => irelandApi.get(`/api/points_statement.csv?pot=${pot}`)
  .then((response) => {
    let filename = 'reward_statements.csv';
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
    FileDownload(response.data, filename);
  })
  .catch(() => {});
